"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePeriod = void 0;
const react_1 = __importStar(require("react"));
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const core_1 = require("@veeam/core");
const controls_1 = require("./..");
const DatePeriodInteractor_1 = require("./DatePeriodInteractor");
const FilterSelector_1 = require("../FilterSelector");
const helpers_1 = require("../../helpers");
const icons_1 = require("../../icons");
exports.DatePeriod = (0, helpers_1.createUIElement)('DatePeriod', (_a, ref) => {
    var { className, texts, value = [], onChange, startDatetime = new Date(0), endDatetime = new Date(9999, 11, 31), defaultInitDate, defaultInitFromDate, defaultInitToDate, dateTimeControlRenderer, disabled, error, size, valueFormatter, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: dataSelectorId } = _a, rest = __rest(_a, ["className", "texts", "value", "onChange", "startDatetime", "endDatetime", "defaultInitDate", "defaultInitFromDate", "defaultInitToDate", "dateTimeControlRenderer", "disabled", "error", "size", "valueFormatter", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    if (defaultInitToDate && defaultInitFromDate && defaultInitToDate < defaultInitFromDate) {
        console.warn('DatePeriod Error: the value of "defaultInitFromDate" property must be greater than the value of "defaultInitToDate" property.');
    }
    const rootRef = (0, react_1.useRef)(null);
    const buttonRef = ref || rootRef;
    const valueModel = (0, core_1.useModelBuilder)(value, [value]);
    const { getValue: getUiTexts, setValue: setUiTexts } = (0, helpers_1.useStateValue)(texts);
    const { interactor } = (0, core_1.useInteractor)(() => new DatePeriodInteractor_1.DatePeriodInteractor(valueModel, { onChange }, {
        texts: getUiTexts,
        valueFormatter
    }));
    const controlTextValue = (0, core_1.useModel)(interactor.textValueModel).value;
    (0, react_1.useEffect)(() => {
        if (!(0, fast_deep_equal_1.default)(getUiTexts(), texts)) {
            setUiTexts(texts);
            interactor.updateTextValue();
        }
    }, [getUiTexts, interactor, setUiTexts, texts]);
    const renderIconBefore = (0, react_1.useCallback)(() => react_1.default.createElement(icons_1.CalendarIcon, { disabled: disabled, error: error }), [disabled, error]);
    const renderValueText = (0, react_1.useCallback)(() => controlTextValue, [controlTextValue]);
    const renderMenu = (0, react_1.useCallback)(({ deactivate }) => {
        interactor.presenter = {
            hideMenu: deactivate
        };
        return (react_1.default.createElement(controls_1.DatePeriodMenu, { texts: texts, value: valueModel.getValue(), startDatetime: startDatetime, endDatetime: endDatetime, defaultInitDate: defaultInitDate, defaultInitFromDate: defaultInitFromDate, defaultInitToDate: defaultInitToDate, dateTimeControlRenderer: dateTimeControlRenderer, onCancel: deactivate, onDone: interactor.didDone }));
    }, [
        dateTimeControlRenderer,
        defaultInitDate,
        defaultInitFromDate,
        defaultInitToDate,
        endDatetime,
        interactor,
        startDatetime,
        texts,
        valueModel
    ]);
    return (react_1.default.createElement(FilterSelector_1.FilterSelector, Object.assign({}, rest, { ref: buttonRef, style: style, "data-selector-id": dataSelectorId, error: error, renderValueText: renderValueText, renderIconBefore: renderIconBefore, disabled: disabled, size: size, renderMenu: renderMenu, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-DatePeriod', className) })));
});
//# sourceMappingURL=DatePeriod.js.map